import { Product } from "@design-controls/types";
import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { designControlsApi } from "../api/designControls";

export const useDeleteProduct = (product: Product) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const { t } = useTranslation();

  return useMutation(
    (productId: string) =>
      designControlsApi.deleteProduct(companyId, productId),
    {
      onSuccess: () => {
        showToast({
          title: t("products.notifications.deleteSuccess.title"),
          description: t("products.notifications.deleteSuccess.description", {
            productName: product.name,
          }),
          status: "success",
          duration: 5000,
          "data-cy": "toast-product-delete-success",
        });
      },
      onError: () => {
        showToast({
          title: t("products.notifications.deleteError.title"),
          description: t("products.notifications.deleteError.description", {
            productName: product.name,
          }),
          status: "error",
          duration: 5000,
          "data-cy": "toast-product-delete-error",
        });
      },
    },
  );
};
